module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIj4KICAgIDxwYXRoIGZpbGw9IiMwMDk2ZmYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTYgMGE2IDYgMCAxIDAgMCAxMkE2IDYgMCAwIDAgNiAwem0zLjI3NCA1LjIwNEw1LjI5IDkuMjcxYS41MjEuNTIxIDAgMCAxLS43NDUgMGwtMS44Mi0xLjg1OGEuNTQ1LjU0NSAwIDAgMSAwLS43Ni41MTkuNTE5IDAgMCAxIC43NDYgMEw0LjkxOCA4LjEzbDMuNjExLTMuNjg3YS41MTkuNTE5IDAgMCAxIC43NDUgMGMuMjA2LjIxLjIwNi41NSAwIC43NjF6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/accept.svg
// module id = ./src/assets/accept.svg
// module chunks = 0